const STORAGE_PREFIX = 'wolfwalker-daily-report-map-viewport';

export function normalizeReportMapViewport(raw) {
  if (!raw || typeof raw !== 'object') return null;

  const lat = Number(raw.lat);
  const lon = Number(raw.lon);
  const zoom = Number(raw.zoom);

  if (!Number.isFinite(lat) || !Number.isFinite(lon) || !Number.isFinite(zoom)) {
    return null;
  }

  return { lat, lon, zoom };
}

export function getReportMapViewportStorageKey(projectId) {
  const id = projectId == null || projectId === '' ? 'all' : String(projectId);
  return `${STORAGE_PREFIX}:${id}`;
}

export function loadReportMapViewport(projectId) {
  try {
    const raw = localStorage.getItem(getReportMapViewportStorageKey(projectId));
    if (!raw) return null;
    return normalizeReportMapViewport(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function saveReportMapViewport(projectId, viewport) {
  const key = getReportMapViewportStorageKey(projectId);
  const normalized = normalizeReportMapViewport(viewport);

  if (!normalized) {
    localStorage.removeItem(key);
    return null;
  }

  localStorage.setItem(key, JSON.stringify(normalized));
  return normalized;
}
